<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>
        
        <h4>
            <span>{{ title }} Datos C.A. {{datoscaPeriodo?.IdCampaniaDescripcion}}</span>
            <span *ngIf="datoscaPeriodo?.DescripcionPeriodo"> - {{datoscaPeriodo?.DescripcionPeriodo}}</span>
        </h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Periodo
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="IdCa">Comunidad Autónoma</label>
                                            <ng-select appendTo="body"
                                                       [items]="comunidades"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdCa"
                                                       loadingText="Cargando..."
                                                       [loading]="(!comunidades || comunidades.length === 0)"
                                                       placeholder="-- Seleccione una Comunidad Autónoma --"
                                                       notFoundText="Comunidad Autónoma no encontrada"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intDescripcion">Nombre</label>
                                            <input formControlName="NombreUsuario" name="NombreUsuario" class="form-control" inputStyleClass="form-control" type="text" value="">
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intDescripcion">Apellidos</label>
                                            <input formControlName="ApellidosUsuario" name="ApellidosUsuario" class="form-control" inputStyleClass="form-control" type="text" value="">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpActiva">Entidades Auditoras</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="EntidadAuditora" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            (onChange)="onSelectEntidad()" offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpActiva">Programa de Verificación</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="ProgramaVerificacion" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedEntidades = !isCollapsedEntidades" [attr.aria-expanded]="!isCollapsedEntidades" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Entidades Auditoras
                                    <i *ngIf="isCollapsedEntidades" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedEntidades" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedDatos" [ngbCollapse]="isCollapsedEntidades">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!--<label class="cabeceraTablaDetalles">Entidades Auditoras</label>-->
                                            <table *ngIf="listaEntidadesPeriodo.length > 0" class="table table-list table-responsive table-sm">
                                                <thead>
                                                    <tr>
                                                        <th class="cabecerasTablaDetalles col-md-1"></th>
                                                        <th class="cabecerasTablaDetalles col-md-3">Razón Social</th>
                                                        <th class="cabecerasTablaDetalles col-md-2">NIF</th>
                                                        <th class="cabecerasTablaDetalles col-md-3">Provincia</th>
                                                        <th class="cabecerasTablaDetalles col-md-3">Localidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of listaEntidadesPeriodo">
                                                        <td scope="col" class="col-md-1">
                                                            <div class="btn-group">
                                                                <ng-container *ngIf="showDeleteButton(item)">
                                                                    <button (click)="onDeleteEntidad(item)" type="button" title="Eliminar Entidad" class="btn btn-sm btn-danger btn-listbox">
                                                                        <i class="fa fa-remove"></i>
                                                                    </button>
                                                                </ng-container>
                                                            </div>
                                                        </td>

                                                        <td scope="col" class="col-md-3">{{item.RazonSocialEa}}</td>
                                                        <td scope="col" class="col-md-2">{{item.NifEa}}</td>
                                                        <td scope="col" class="col-md-3">{{item.ProvinciaEa}}</td>
                                                        <td scope="col" class="col-md-3">{{item.LocalidadEa}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div class="empty-grid" *ngIf="listaEntidadesPeriodo.length === 0">No se ha encontrado ningún registro</div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--USUARIOS CA POR DEFECTO-->
                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedUsuarioCaDefault = !isCollapsedUsuarioCaDefault" [attr.aria-expanded]="!isCollapsedUsuarioCaDefault" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Usuarios por defecto
                                    <i *ngIf="isCollapsedUsuarioCaDefault" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedUsuarioCaDefault" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedUsuarioCaDefault" [ngbCollapse]="isCollapsedUsuarioCaDefault">

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : usuariosCaAceptacionRequired}" for="IdUsuarioDefaultAceptacion">Usuario CA Aceptación</label>
                                            <ng-select appendTo="body"
                                                       [items]="usuariosCaAceptacion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdUsuarioDefaultAceptacion"
                                                       loadingText="Cargando..."
                                                       [loading]="(!usuariosCaAceptacion || usuariosCaAceptacion.length === 0)"
                                                       placeholder="-- Seleccione un Usuario CA --"
                                                       notFoundText="Usuario CA no encontrado"
                                                       [ngClass]="displayFieldCssNgSelect('IdUsuarioDefaultAceptacion')"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUsuarioDefaultAceptacion','required')">
                                                Usuario CA es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : usuariosCaUnidadInspeccionRequired}" for="IdUsuarioDefaultUnidadInspeccion">Usuario CA Unidad Inspección</label>
                                            <ng-select appendTo="body"
                                                       [items]="usuariosCaUnidadInspeccion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdUsuarioDefaultUnidadInspeccion"
                                                       loadingText="Cargando..."
                                                       [loading]="(!usuariosCaUnidadInspeccion || usuariosCaUnidadInspeccion.length === 0)"
                                                       placeholder="-- Seleccione un Usuario CA --"
                                                       notFoundText="Usuario CA no encontrado"
                                                       [ngClass]="displayFieldCssNgSelect('IdUsuarioDefaultUnidadInspeccion')"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUsuarioDefaultUnidadInspeccion','required')">
                                                Usuario CA es obligatorio
                                            </div>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" [ngClass]="{ 'required-field' : usuariosCaAforoCorteRequired}" for="IdUsuarioDefaultAforoCorte">Usuario CA Aforo/Corte</label>
                                            <ng-select appendTo="body"
                                                       [items]="usuariosCaAforoCorte"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdUsuarioDefaultAforoCorte"
                                                       loadingText="Cargando..."
                                                       [loading]="(!usuariosCaAforoCorte || usuariosCaAforoCorte.length === 0)"
                                                       placeholder="-- Seleccione un Usuario CA --"
                                                       notFoundText="Usuario CA no encontrado"
                                                       [ngClass]="displayFieldCssNgSelect('IdUsuarioDefaultAforoCorte')"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUsuarioDefaultAforoCorte','required')">
                                                Usuario CA es obligatorio
                                            </div>
                                        </div>
                                    </div>                                    

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>
